import { render, staticRenderFns } from "./changeAddress.vue?vue&type=template&id=01d0889a"
import script from "./changeAddress.vue?vue&type=script&lang=js"
export * from "./changeAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports